import React, { Component } from "react";
import { Div, Row, Col, Text } from "atomize";

import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";

export default class EngagementPoints extends Component {
  render() {
    const { content } = this.props;
    return (
      <WebsiteContainer>
        <CustomContainer>
          <Div className="solutions">
            <Text
              maxW="25.2rem"
              textSize="title2"
              tag="h2"
              textWeight="bold"
              m={{ b: "2.3rem" }}
            >
              {content.heading}
            </Text>
            <Row>
              {content.points.map((data, index) => {
                return (
                  <Col size={{ xs: "12", md: "4" }} key={index}>
                    <Div m={{ b: { xs: "4.75rem", md: "0" } }}>
                      <Text
                        fontFamily="secondary"
                        textWeight="bold"
                        textColor="gray700"
                      >
                        {data.count}
                      </Text>
                      <Text
                        p={{ t: ".56rem", b: ".375rem" }}
                        textSize={{ xs: "subheader1", md: "subheader6" }}
                        textWeight="bold"
                        maxW={{ xs: "100%", md: "10.75rem" }}
                        tag="h3"
                      >
                        {data.heading}
                      </Text>
                      <Div maxW={{ xs: "100%", md: "17.125rem" }}>
                        <Text
                          style={{ lineHeight: "24px" }}
                          fontSize={{ xs: "15px", md: "14px" }}
                          textColor="#D9D9D9"
                          m={{ b: "1rem" }}
                        >
                          {data.text1}
                        </Text>
                        <Text
                          style={{ lineHeight: "24px" }}
                          fontSize={{ xs: "15px", md: "14px" }}
                          textColor="#D9D9D9"
                        >
                          {data.text2}
                        </Text>
                      </Div>
                    </Div>
                  </Col>
                );
              })}
            </Row>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}
